import { IconArrowUpRight } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { gaPushEvent } from "../../../tools/analytics/base.analytics";
import { Tabs } from "../../../components/ui/Tabs";
import type { ArticlePageTabName } from "../hooks/useArticlePageUIState";

export interface ArticlePageTabsProps {
  enabledTabs: ArticlePageTabName[];
  activeTab: ArticlePageTabName;
  setActiveTab: (tab: ArticlePageTabName) => void;
  contentTopRef: React.Ref<HTMLDivElement>;
  onTabChange: ((tab: ArticlePageTabName) => void) | null;
}

export default function ArticlePageTabs({
  enabledTabs,
  activeTab,
  setActiveTab,
  contentTopRef,
  onTabChange,
}: ArticlePageTabsProps): React.JSX.Element {
  const { t } = useTranslation();

  const tabConfig: Record<
    ArticlePageTabName,
    { label: string; icon: React.ReactNode | null }
  > = {
    overview: { label: t("Overview"), icon: null },
    abstract: { label: t("Abstract"), icon: null },
    // Only tab whose content sends the reader off Juisci (DOI + publisher
    // link), so it carries the external-link glyph.
    source: {
      label: t("Source"),
      icon: <IconArrowUpRight size={16} stroke={2} />,
    },
  };

  return (
    <div ref={contentTopRef}>
      <Tabs
        className="sticky top-0"
        tabs={enabledTabs.map((tab) => ({
          value: tab,
          ...tabConfig[tab],
          badge: null,
        }))}
        activeTab={activeTab}
        onTabChange={(tab) => {
          gaPushEvent("article_tabs_clicked", { destination: tab });
          if (onTabChange !== null) onTabChange(tab);
          setActiveTab(tab);
        }}
      />
    </div>
  );
}
